export default "__VITE_ASSET__32084228__"